// @ts-nocheck
import angular from 'angular';

export class UsersController {
  BODACDC_3010 = FEATURE_BODACDC_3010;
  /* @ngInject */
  constructor($log, $state, $timeout, $location, Users) {
    Object.assign(this, {
      $log,
      $state,
      $location,
      $timeout,
      Users,
      pagination: {},
      showSearch: true,
    });
    $timeout(() => {
      angular.element(document.getElementById('patient-search')).focus();
    }, 250);
    this.search();
  }


  sanitizeSearchTerm() {
    if (this.pagination.search?.startsWith('+44')) {
      this.pagination.search = '0' + this.pagination.search.slice(3);
    }
  }


  search() {
    this.loading = true;

    if (this.BODACDC_3010) {
      this.sanitizeSearchTerm();
    }

   this.Users.search({ ...this.pagination })
      .then(({ data }) => {
        this.$log.debug('Users: ', data);
        Object.assign(this.pagination, data.pagination);
        this.users = data.data;
        this.$location.search({
          offset: this.pagination.offset,
          limit: this.pagination.limit,
          search: this.pagination.search,
        });
      })
      .catch(err => this.$log.error(err))
      .finally(() => {
        this.loading = false;
      });
  }
}

UsersController.$inject = ["$log", "$state", "$timeout", "$location", "Users"];
angular.module('pims').controller('UsersController', UsersController);
